export function TeamIcon(fill) {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7171 10.3764L10.7169 10.3762C10.5416 10.1595 10.5745 9.84114 10.792 9.66537M10.7171 10.3764L11.4276 10.451C12.0498 9.94744 12.8364 9.66987 13.6422 9.66987C15.5721 9.66987 17.1394 11.2212 17.1394 13.1246V14.2869C17.1394 14.317 17.1128 14.3489 17.0713 14.3489H12.6139C12.335 14.3489 12.1085 14.5753 12.1085 14.8542C12.1085 15.1333 12.335 15.3595 12.6139 15.3595H17.0712C17.6653 15.3595 18.1499 14.8793 18.1499 14.2869V13.1246C18.1499 10.6608 16.1265 8.6592 13.6422 8.6592C12.6059 8.6592 11.5939 9.01648 10.792 9.66537M10.7171 10.3764C10.8929 10.5931 11.2109 10.6266 11.4276 10.4511L10.7171 10.3764ZM10.792 9.66537L10.8863 9.78203M10.792 9.66537C10.792 9.66539 10.792 9.66541 10.7919 9.66543L10.8863 9.78203M10.8863 9.78203C10.7334 9.90557 10.7102 10.1294 10.8336 10.2819L10.8863 9.78203Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.3"
      />
      <path
        d="M10.9367 5.75981C10.9367 7.24012 12.1515 8.44191 13.6422 8.44191C15.1329 8.44191 16.3481 7.24033 16.3481 5.75981C16.3481 4.27931 15.1331 3.07754 13.6422 3.07754C12.1514 3.07754 10.9367 4.27951 10.9367 5.75981ZM11.9473 5.75981C11.9473 4.84003 12.706 4.08821 13.6422 4.08821C14.5786 4.08821 15.3374 4.84006 15.3374 5.75981C15.3374 6.67955 14.5788 7.43124 13.6422 7.43124C12.706 7.43124 11.9473 6.67957 11.9473 5.75981Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.3"
      />
      <path
        d="M2.16195 16.7849H11.8073C12.5299 16.7849 13.1193 16.2014 13.1193 15.4814V13.8467C13.1193 10.4954 10.3662 7.77175 6.98463 7.77175C3.60301 7.77175 0.85 10.4954 0.85 13.8467V15.4814C0.85 16.2014 1.4394 16.7849 2.16195 16.7849ZM1.86067 13.8469C1.86067 11.0562 4.15778 8.78259 6.98463 8.78259C9.81148 8.78259 12.1086 11.0562 12.1084 13.8469V15.4816C12.1084 15.6402 11.9758 15.7744 11.8071 15.7744H2.16195C1.99328 15.7744 1.86067 15.6402 1.86067 15.4816V13.8469Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.3"
      />
      <path
        d="M3.42715 4.253C3.42715 6.1312 4.96903 7.65635 6.86121 7.65635C8.75354 7.65635 10.2954 6.13138 10.2954 4.25317C10.2954 2.37515 8.75372 0.85 6.86121 0.85C4.96887 0.85 3.42715 2.37497 3.42715 4.253ZM4.43782 4.25317C4.43782 2.93582 5.52343 1.86067 6.86121 1.86067C8.19916 1.86067 9.28477 2.93583 9.28477 4.25317C9.28477 5.5707 8.19916 6.64586 6.86121 6.64586C5.52344 6.64586 4.43782 5.57071 4.43782 4.25317Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.3"
      />
    </svg>
  );
}

const BRAND_BLUE = '#2D70E2';

const normalizeColor = (value) => {
  if (!value) return '';
  return `${value}`.trim().toLowerCase();
};

const withNoraBase = (strokeColor, strokeWidth = 1.155) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 9.5H12M8 13H15M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21Z"
      stroke={strokeColor}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export function NoraIcon(input) {
  const props = typeof input === 'string' ? { color: input } : input || {};
  const {
    color: providedColor = '#111827',
    gradient,
    gradientId,
    strokeWidth = 1.155,
  } = props;

  if (gradient) {
    const gradientRef = gradientId || 'nora-icon-gradient';
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id={gradientRef} x1="3" y1="3" x2="21" y2="21" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor={gradient.from} />
            <stop offset="100%" stopColor={gradient.to} />
          </linearGradient>
        </defs>
        <path
          d="M8 9.5H12M8 13H15M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 13.1971 3.23374 14.3397 3.65806 15.3845C3.73927 15.5845 3.77988 15.6845 3.798 15.7653C3.81572 15.8443 3.8222 15.9028 3.82221 15.9839C3.82222 16.0667 3.80718 16.1569 3.77711 16.3374L3.18413 19.8952C3.12203 20.2678 3.09098 20.4541 3.14876 20.5888C3.19933 20.7067 3.29328 20.8007 3.41118 20.8512C3.54589 20.909 3.73218 20.878 4.10476 20.8159L7.66265 20.2229C7.84309 20.1928 7.9333 20.1778 8.01613 20.1778C8.09715 20.1778 8.15566 20.1843 8.23472 20.202C8.31554 20.2201 8.41552 20.2607 8.61549 20.3419C9.6603 20.7663 10.8029 21 12 21Z"
          stroke={`url(#${gradientRef})`}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return withNoraBase(providedColor, strokeWidth);
}

export function NoraNavIcon(fill) {
  const normalized = normalizeColor(fill);
  const isSelected = normalized === 'white' || normalized === '#fff' || normalized === '#ffffff';
  const strokeColor = isSelected ? BRAND_BLUE : fill;
  return withNoraBase(strokeColor, 1.155);
}

export function staplesReportIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 2.26953V6.40007C14 6.96012 14 7.24015 14.109 7.45406C14.2049 7.64222 14.3578 7.7952 14.546 7.89108C14.7599 8.00007 15.0399 8.00007 15.6 8.00007H19.7305M16 13H8M16 17H8M10 9H8M14 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H15.2C16.8802 22 17.7202 22 18.362 21.673C18.9265 21.3854 19.3854 20.9265 19.673 20.362C20 19.7202 20 18.8802 20 17.2V8L14 2Z"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function actionIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4666 2.08909L16.4666 2.08908C18.3715 1.30022 20.3831 0.9 22.4449 0.9C22.7375 0.9 22.9746 1.13712 22.9746 1.42969C22.9746 3.49155 22.5746 5.5031 21.7854 7.4082C21.2871 8.61122 20.6484 9.7343 19.8785 10.7662C19.8787 10.7743 19.8787 10.7827 19.8785 10.7913C19.8785 10.7913 19.8785 10.7914 19.8785 10.7914L19.86 10.7909C19.8588 10.7925 19.8575 10.7941 19.8563 10.7958L19.8495 10.7906L19.7785 10.7886M16.4666 2.08909L3.82657 9.38074C3.65872 9.54858 3.65872 9.82066 3.82657 9.98851L5.73062 11.8924L7.04502 13.2068M16.4666 2.08909C15.2634 2.58757 14.1404 3.22618 13.1085 3.99603M16.4666 2.08909L4.62111 18.6569M19.7785 10.7886L19.8493 10.7905L19.7763 10.7358M19.7785 10.7886C19.779 10.7707 19.778 10.753 19.7763 10.7358M19.7785 10.7886C19.709 13.4213 18.6452 15.8967 16.7831 17.759M19.7763 10.7358C20.5511 9.7025 21.1931 8.57675 21.693 7.36994C22.4771 5.47696 22.8746 3.47842 22.8746 1.42969C22.8746 1.19235 22.6823 1 22.4449 1C20.3962 1 18.3976 1.39763 16.5048 2.18147C15.298 2.68148 14.1724 3.32333 13.1392 4.09794M19.7763 10.7358L13.0861 4.09609M16.7831 17.759L14.4939 20.048C14.41 20.132 14.3 20.1739 14.1901 20.1739C14.0801 20.1739 13.97 20.132 13.8861 20.048M16.7831 17.759L16.8538 17.8297L14.5646 20.1188C14.4612 20.2222 14.3255 20.2739 14.1901 20.2739C14.0547 20.2739 13.9188 20.2222 13.8154 20.1188L13.8861 20.048M16.7831 17.759L10.6641 16.9674M13.8861 20.048L11.9822 18.144L10.6678 16.8298M13.8861 20.048L13.8154 20.1187L11.9115 18.2147L10.6641 16.9674M10.6678 16.8298C9.34284 18.0304 7.66169 18.8181 5.88772 19.0609L5.20408 19.1544M10.6678 16.8298L10.5971 16.9005L10.6641 16.9674M10.6678 16.8298L10.735 16.9039C10.7114 16.9252 10.6878 16.9464 10.6641 16.9674M5.20408 19.1544C5.18461 19.1571 5.16514 19.1585 5.14584 19.1585C5.03271 19.1585 4.92328 19.1138 4.84204 19.0326C4.74704 18.9376 4.70189 18.8036 4.72018 18.6705M5.20408 19.1544L5.21775 19.2535C5.19381 19.2568 5.16978 19.2585 5.14584 19.2585C5.00638 19.2585 4.87145 19.2034 4.77133 19.1033C4.65425 18.9862 4.59856 18.8211 4.62111 18.657M5.20408 19.1544L4.62111 18.657M4.72018 18.6705L4.81384 17.9869C5.05671 16.2129 5.84442 14.5318 7.04502 13.2068M4.72018 18.6705L4.62111 18.657M4.72018 18.6705L4.62111 18.6569M7.04502 13.2068L6.97092 13.1396C6.9496 13.1632 6.92842 13.1868 6.90736 13.2105M7.04502 13.2068L6.97431 13.2775L6.90736 13.2105M6.90736 13.2105C5.72907 14.5392 4.95608 16.2108 4.71476 17.9733L4.62111 18.6569M6.90736 13.2105L5.65991 11.9631L3.75586 10.0592L3.75586 10.0592C3.54896 9.85232 3.54896 9.51692 3.75586 9.31002L6.04511 7.02077C6.04511 7.02077 6.04511 7.02077 6.04511 7.02077C7.92531 5.1404 10.4252 4.06629 13.0835 3.99613L13.084 4.01434C13.0886 4.01091 13.0931 4.00748 13.0977 4.00406C13.1013 4.00138 13.1049 3.99871 13.1085 3.99603M4.62111 18.6569L4.62111 18.657M13.1085 3.99603C13.122 3.99631 13.1356 3.9971 13.149 3.99842L13.1392 4.09794M13.1085 3.99603C13.1049 3.99596 13.1013 3.99593 13.0977 3.99593C13.0942 3.99593 13.0882 3.99591 13.0818 3.99619L13.0826 4.01535C13.0815 4.01621 13.0803 4.01707 13.0792 4.01793L13.083 4.02295L13.0861 4.09609M13.1392 4.09794L13.0977 4.04264L13.0843 4.02468L13.0861 4.09609M13.1392 4.09794C13.1256 4.0966 13.1117 4.09593 13.0977 4.09593C13.0939 4.09593 13.09 4.09593 13.0861 4.09609M6.03442 10.8394L4.87956 9.68453L6.79413 7.7698C6.79414 7.7698 6.79414 7.76979 6.79414 7.76979C8.13898 6.42512 9.8363 5.53991 11.6774 5.20365C11.5834 5.29298 11.4903 5.38359 11.3983 5.47554L11.3982 5.47557L6.03442 10.8394ZM18.6708 12.1973C18.3347 14.0384 17.4495 15.7357 16.1046 17.0805L16.1754 17.1512L16.1046 17.0805L14.1901 18.9952L13.035 17.8402L14.1146 16.7606C14.3213 16.5539 14.3213 16.2185 14.1146 16.0117L14.1146 16.0116C13.9077 15.8047 13.5723 15.8047 13.3654 16.0116L12.286 17.091L11.05 15.8552L6.78345 11.5886L12.1474 6.22477L12.0767 6.15406L12.1474 6.22477C14.7706 3.60142 18.2176 2.10242 21.9054 1.96901C21.7722 5.65699 20.2732 9.10399 17.6498 11.7272L17.7206 11.7979L17.6498 11.7272L15.9326 13.4444C15.7257 13.6513 15.7257 13.9867 15.9326 14.1936L15.9326 14.1936C16.1395 14.4003 16.4747 14.4003 16.6816 14.1936L16.6816 14.1936L18.3989 12.4764C18.4909 12.3844 18.5815 12.2913 18.6708 12.1973ZM5.7653 18.1093C5.9765 16.5779 6.64276 15.1236 7.65759 13.9609L9.91383 16.217C8.75095 17.2319 7.29664 17.8981 5.7653 18.1093Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M14.6256 14.7515C14.5267 14.8503 14.4708 14.9862 14.4708 15.126C14.4708 15.2652 14.5266 15.4017 14.6257 15.5006L14.6258 15.5006C14.7246 15.5991 14.8604 15.6557 15.0005 15.6557C15.1402 15.6557 15.2759 15.599 15.3748 15.5007L15.375 15.5005C15.4736 15.4019 15.5302 15.2655 15.5302 15.126C15.5302 14.9859 15.4736 14.8501 15.375 14.7515C15.2758 14.6522 15.1395 14.5963 15.0005 14.5963C14.8607 14.5963 14.7248 14.6522 14.6256 14.7515ZM14.6256 14.7515C14.6257 14.7514 14.6257 14.7514 14.6257 14.7514L14.6963 14.8222M14.6256 14.7515C14.6256 14.7515 14.6256 14.7515 14.6256 14.7515L14.6963 14.8222M14.6963 14.8222C14.6163 14.9021 14.5708 15.0125 14.5708 15.126C14.5708 15.2389 14.6163 15.3499 14.6963 15.4298H15.3043C15.3842 15.3499 15.4302 15.2389 15.4302 15.126C15.4302 15.0125 15.3842 14.9021 15.3043 14.8222C15.2239 14.7418 15.1131 14.6963 15.0005 14.6963C14.887 14.6963 14.7766 14.7418 14.6963 14.8222Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M11.7545 10.4384L11.7545 10.4384C11.5297 10.6632 11.4062 10.9614 11.4062 11.2793C11.4062 11.597 11.5297 11.8953 11.7545 12.12L11.7545 12.12C11.9792 12.3448 12.2775 12.4684 12.5952 12.4684C12.9131 12.4684 13.2113 12.3448 13.4361 12.12C13.6607 11.8954 13.7843 11.597 13.7843 11.2793C13.7843 10.9614 13.6607 10.6632 13.4361 10.4384C13.4361 10.4384 13.4361 10.4384 13.436 10.4384M11.7545 10.4384L11.6838 10.3677C11.9272 10.1242 12.251 9.99023 12.5952 9.99023C12.9396 9.99023 13.2632 10.1242 13.5068 10.3677L13.436 10.4384M11.7545 10.4384C11.9791 10.2137 12.2774 10.0902 12.5952 10.0902C12.9131 10.0902 13.2113 10.2136 13.436 10.4384M11.7545 10.4384H13.436M12.5952 9.03086C13.1956 9.03086 13.7606 9.26478 14.1851 9.68939C14.6097 10.1138 14.8436 10.6789 14.8436 11.2793C14.8436 11.8795 14.6097 12.4445 14.1851 12.869C14.1851 12.869 14.1851 12.869 14.1851 12.869M12.5952 9.03086L11.0762 12.7983C11.4819 13.2042 12.0215 13.4277 12.5952 13.4277C13.1691 13.4277 13.7087 13.2042 14.1144 12.7983L14.1851 12.869M12.5952 9.03086C11.995 9.03086 11.43 9.26478 11.0055 9.68939M12.5952 9.03086L11.0055 12.869M14.1851 12.869C13.7606 13.2936 13.1956 13.5277 12.5952 13.5277C11.995 13.5277 11.4299 13.2936 11.0055 12.869M14.1851 12.869L11.0055 12.869M11.0055 12.869C10.5809 12.4446 10.3468 11.8795 10.3468 11.2793C10.3468 10.6789 10.5809 10.1139 11.0055 9.68942M11.0055 9.68942L11.0762 9.76012L11.0055 9.68939M11.0055 9.68942C11.0055 9.68941 11.0055 9.68941 11.0055 9.6894M11.0055 9.68942C11.0055 9.68941 11.0055 9.68941 11.0055 9.6894M11.0055 9.68939C11.0055 9.68939 11.0055 9.6894 11.0055 9.6894M11.0055 9.68939L11.0055 9.6894"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M15.3246 8.54983L15.3247 8.54986C15.7493 8.97427 16.3141 9.20839 16.9145 9.20839C17.5149 9.20839 18.08 8.97428 18.5044 8.54984C18.929 8.12524 19.163 7.56034 19.163 6.95996C19.163 6.35958 18.9291 5.79451 18.5044 5.37005C18.08 4.94544 17.5149 4.71152 16.9145 4.71152C16.3142 4.71152 15.7493 4.94546 15.3247 5.37007C14.9002 5.79451 14.6661 6.35957 14.6661 6.95996C14.6661 7.56036 14.9002 8.12524 15.3246 8.54983ZM16.0739 6.11909L16.0739 6.11907C16.2985 5.89432 16.5968 5.7709 16.9145 5.7709C17.2325 5.7709 17.5306 5.89432 17.7554 6.11909C17.9802 6.34387 18.1036 6.64204 18.1036 6.95996C18.1036 7.27772 17.9802 7.57604 17.7554 7.80063L17.7554 7.80065C17.5306 8.02545 17.2324 8.14902 16.9145 8.14902C16.5968 8.14902 16.2985 8.02544 16.0739 7.80068L16.0738 7.80063C15.8491 7.57601 15.7255 7.27769 15.7255 6.95996C15.7255 6.64207 15.8491 6.34389 16.0739 6.11909Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M11.4646 19.4106C11.6716 19.2039 11.6715 18.8684 11.4646 18.6616C11.2579 18.4549 10.9225 18.4546 10.7156 18.6616C10.7156 18.6616 10.7156 18.6616 10.7156 18.6616L7.7793 21.5977L7.7793 21.5977C7.5724 21.8046 7.5724 22.14 7.7793 22.3469L7.77937 22.347C7.88276 22.4501 8.01842 22.5019 8.15381 22.5019C8.28919 22.5019 8.42485 22.4501 8.52825 22.347L8.52832 22.3469L11.4646 19.4106ZM11.4646 19.4106L11.3939 19.3399L11.4646 19.4106L11.4646 19.4106Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M3.99912 16.0109L3.99913 16.0109C4.20602 15.804 4.20602 15.4686 3.99913 15.2617C3.79223 15.0548 3.457 15.0548 3.2501 15.2617L1.18412 17.3277C0.97715 17.5345 0.977201 17.8699 1.18408 18.0768C1.2875 18.1802 1.4232 18.2319 1.55859 18.2319C1.69399 18.2319 1.82969 18.1802 1.9331 18.0768C1.9331 18.0768 1.9331 18.0768 1.93311 18.0768L3.99912 16.0109Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M5.25492 14.7551L5.25514 14.7549C5.35376 14.6563 5.41032 14.5201 5.41032 14.3804C5.41032 14.2409 5.35377 14.1045 5.25514 14.0059L5.25514 14.0059L5.25492 14.0056C5.15601 13.9073 5.02031 13.8507 4.88063 13.8507C4.74088 13.8507 4.60482 13.9073 4.50584 14.0056L4.50584 14.0056L4.50561 14.0059C4.40698 14.1045 4.35044 14.2409 4.35044 14.3804C4.35044 14.5201 4.407 14.6563 4.50561 14.7549L4.50584 14.7551C4.60482 14.8535 4.74088 14.9101 4.88063 14.9101C5.02031 14.9101 5.15601 14.8534 5.25492 14.7551Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
      <path
        d="M7.30779 20.9937C7.51476 20.7869 7.51471 20.4515 7.30783 20.2446C7.10093 20.0377 6.7657 20.0377 6.5588 20.2446L4.60742 22.196C4.40052 22.4029 4.40052 22.7381 4.60742 22.945C4.71084 23.0484 4.84654 23.1002 4.98193 23.1002C5.11733 23.1002 5.25303 23.0484 5.35645 22.945L7.30779 20.9937ZM7.30779 20.9937L7.23712 20.9229L7.30783 20.9937L7.30779 20.9937Z"
        fill={fill}
        stroke={fill}
        strokeWidth="0.2"
      />
    </svg>
  );
}

export function cultureIcon(fill) {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0926 21C5.31751 21 0.569092 16.2622 0.569092 10.5C0.569092 4.73781 5.31751 0 11.0926 0C16.8677 0 21.6162 4.73781 21.6162 10.5C21.6162 16.2622 16.8677 21 11.0926 21ZM11.0926 1.28049C5.95919 1.28049 1.85245 5.37805 1.85245 10.5C1.85245 15.622 5.95919 19.7195 11.0926 19.7195C16.2261 19.7195 20.3328 15.622 20.3328 10.5C20.3328 5.37805 16.2261 1.28049 11.0926 1.28049Z"
        fill={fill}
      />
      <path
        d="M4.03417 11.3965H6.08754C7.11423 11.3965 7.11423 9.85989 6.08754 9.85989H4.03417C3.00749 9.85989 3.00749 11.3965 4.03417 11.3965Z"
        fill={fill}
      />
      <path
        d="M5.57425 6.14644C6.08759 6.65864 6.60093 7.17083 6.98594 7.55498C7.75596 8.32327 8.91098 7.17083 8.14096 6.40253L6.72927 4.994C5.95925 4.22571 4.80424 5.37815 5.57425 6.14644Z"
        fill={fill}
      />
      <path
        d="M10.1943 3.58531V5.63409C10.1943 6.65848 11.7344 6.65848 11.7344 5.63409V3.58531C11.7344 2.56092 10.1943 2.56092 10.1943 3.58531Z"
        fill={fill}
      />
      <path
        d="M15.3275 4.994C14.8142 5.5062 14.3008 6.01839 13.9158 6.40253C13.1458 7.17083 14.3008 8.32327 15.0708 7.55498L16.4825 6.14644C17.2525 5.37815 16.0975 4.22571 15.3275 4.994Z"
        fill={fill}
      />
      <path
        d="M18.0228 9.73172H15.9695C14.9428 9.73172 14.9428 11.2683 15.9695 11.2683H18.0228C19.0495 11.2683 19.0495 9.73172 18.0228 9.73172Z"
        fill={fill}
      />
      <path
        d="M16.6112 14.8538C16.0978 14.3416 15.5845 13.8294 15.1995 13.4453C14.4295 12.677 13.2744 13.8294 14.0445 14.5977L15.4562 16.0062C16.2262 16.7745 17.3812 15.6221 16.6112 14.8538Z"
        fill={fill}
      />
      <path
        d="M11.8625 17.4148V15.366C11.8625 14.3416 10.3225 14.3416 10.3225 15.366V17.4148C10.3225 18.4392 11.8625 18.4392 11.8625 17.4148Z"
        fill={fill}
      />
      <path
        d="M6.72927 16.0062L8.14096 14.5977C8.91098 13.8294 7.75596 12.677 6.98594 13.4453L5.57425 14.8538C4.80424 15.6221 5.95925 16.7745 6.72927 16.0062Z"
        fill={fill}
      />
    </svg>
  );
}

export function calendarIcon(fill) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_158)">
        <path
          d="M3.02222 20H16.9778C18.4407 20 19.6296 18.8111 19.6296 17.3481V4.13331C19.6296 2.67035 18.4407 1.48145 16.9778 1.48145H15.9259V0.740727C15.9259 0.333315 15.5926 0 15.1851 0C14.7777 0 14.4444 0.333315 14.4444 0.740727V1.48145H5.55557V0.740727C5.55557 0.333315 5.2222 0 4.81479 0C4.40737 0 4.07406 0.333315 4.07406 0.740727V1.48145H3.02222C1.55926 1.48145 0.370361 2.67035 0.370361 4.13331V17.3481C0.370361 18.8111 1.55926 20 3.02222 20ZM1.85188 4.13331C1.85188 3.48889 2.3778 2.96297 3.02222 2.96297H4.07406V3.7037C4.07406 4.11111 4.40737 4.44442 4.81479 4.44442C5.2222 4.44442 5.55551 4.11111 5.55551 3.7037V2.96297H14.4444V3.7037C14.4444 4.11111 14.7777 4.44442 15.1851 4.44442C15.5926 4.44442 15.9259 4.11111 15.9259 3.7037V2.96297H16.9777C17.6221 2.96297 18.1481 3.48889 18.1481 4.13331V17.3481C18.1481 17.9926 17.6221 18.5185 16.9777 18.5185H3.02222C2.3778 18.5185 1.85188 17.9926 1.85188 17.3481V4.13331Z"
          fill={fill}
        />
        <path
          d="M5.74085 8.51847C6.25222 8.51847 6.66676 8.10393 6.66676 7.59256C6.66676 7.0812 6.25222 6.66666 5.74085 6.66666C5.22948 6.66666 4.81494 7.0812 4.81494 7.59256C4.81494 8.10393 5.22948 8.51847 5.74085 8.51847Z"
          fill={fill}
        />
        <path
          d="M9.81482 8.51847C10.3262 8.51847 10.7407 8.10393 10.7407 7.59256C10.7407 7.0812 10.3262 6.66666 9.81482 6.66666C9.30346 6.66666 8.88892 7.0812 8.88892 7.59256C8.88892 8.10393 9.30346 8.51847 9.81482 8.51847Z"
          fill={fill}
        />
        <path
          d="M13.8888 8.51847C14.4002 8.51847 14.8147 8.10393 14.8147 7.59256C14.8147 7.0812 14.4002 6.66666 13.8888 6.66666C13.3774 6.66666 12.9629 7.0812 12.9629 7.59256C12.9629 8.10393 13.3774 8.51847 13.8888 8.51847Z"
          fill={fill}
        />
        <path
          d="M5.74085 12.2222C6.25222 12.2222 6.66676 11.8076 6.66676 11.2963C6.66676 10.7849 6.25222 10.3704 5.74085 10.3704C5.22948 10.3704 4.81494 10.7849 4.81494 11.2963C4.81494 11.8076 5.22948 12.2222 5.74085 12.2222Z"
          fill={fill}
        />
        <path
          d="M9.81482 12.2222C10.3262 12.2222 10.7407 11.8076 10.7407 11.2963C10.7407 10.7849 10.3262 10.3704 9.81482 10.3704C9.30346 10.3704 8.88892 10.7849 8.88892 11.2963C8.88892 11.8076 9.30346 12.2222 9.81482 12.2222Z"
          fill={fill}
        />
        <path
          d="M13.8888 12.2222C14.4002 12.2222 14.8147 11.8076 14.8147 11.2963C14.8147 10.7849 14.4002 10.3704 13.8888 10.3704C13.3774 10.3704 12.9629 10.7849 12.9629 11.2963C12.9629 11.8076 13.3774 12.2222 13.8888 12.2222Z"
          fill={fill}
        />
        <path
          d="M5.74085 15.9259C6.25222 15.9259 6.66676 15.5113 6.66676 15C6.66676 14.4886 6.25222 14.0741 5.74085 14.0741C5.22948 14.0741 4.81494 14.4886 4.81494 15C4.81494 15.5113 5.22948 15.9259 5.74085 15.9259Z"
          fill={fill}
        />
        <path
          d="M9.81482 15.9259C10.3262 15.9259 10.7407 15.5113 10.7407 15C10.7407 14.4886 10.3262 14.0741 9.81482 14.0741C9.30346 14.0741 8.88892 14.4886 8.88892 15C8.88892 15.5113 9.30346 15.9259 9.81482 15.9259Z"
          fill={fill}
        />
        <path
          d="M13.8888 15.9259C14.4002 15.9259 14.8147 15.5113 14.8147 15C14.8147 14.4886 14.4002 14.0741 13.8888 14.0741C13.3774 14.0741 12.9629 14.4886 12.9629 15C12.9629 15.5113 13.3774 15.9259 13.8888 15.9259Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1_158">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}


export function dataScienceIcon(fill){
  return (
  <svg xmlns="http://www.w3.org/2000/svg"  width="15" height="15">
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" preserveAspectRatio="xMinYMid" viewBox="0 0 25 25">
  <path fill="#b7b7b7" d="M23 3.4C23 1.7 18.4.2 12.7.2S2.2 1.8 2.2 3.5c0 .2.1.5.2.6l-.5-.5v18h.4C8.4 11.3 22.7 4.5 22.7 4.5c-.2.1-.4.1-.5.2.4-.4.8-.9.8-1.3z" className="colorA0CEC7 svgShape"/>
  <path fill={fill} d="M23.4 3.6c.1-2.1-5-3.6-10.9-3.6S1.6 1.4 1.6 3.6v18s0-2 0 0S6.8 25 12.5 25s10.9-1.3 10.9-3.4v-18zM12.5.6c6.1 0 10.2 1.5 10.2 2.9 0 1.5-4.1 2.9-10.2 2.9S2.3 5 2.3 3.6s4.1-3 10.2-3zm10.2 21c-.3 1.4-4.4 2.7-10.2 2.7s-9.9-1.4-10.2-2.7v-5.4c1.2 1.5 5.2 2.5 10.2 2.5 4.9 0 9-1 10.2-2.4v5.3zm0-6.1c-.4 1.4-4.4 2.7-10.2 2.7s-9.9-1.4-10.2-2.7v.1-5C3.5 12.1 7.5 13 12.5 13c4.9 0 9-1 10.2-2.4v4.9zm0-5.7c-.4 1.4-4.4 2.7-10.2 2.7S2.6 11.1 2.3 9.8v.2-5.4c1.2 1.3 5.3 2.5 10.2 2.5s9-1 10.2-2.4v5.1z" className="color222 svgShape"/>
  <circle cx="20.1" cy="8.7" r=".9" fill="none" stroke={fill} strokeMiterlimit="10" strokeWidth=".497" className="colorStroke222 svgStroke"/>
  <circle cx="20.1" cy="14.7" r=".9" fill="none" stroke={fill} strokeMiterlimit="10" strokeWidth=".497" className="colorStroke222 svgStroke"/>
  <circle cx="20.1" cy="20.7" r=".9" fill="none" stroke={fill} strokeMiterlimit="10" strokeWidth=".497" className="colorStroke222 svgStroke"/></svg></svg>
  )
}

export function groupIcon(fill){
  return (
   <svg width="15" height="15" viewBox="0 0 576 512" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M264.5 5.20002C279.4 -1.69998 296.6 -1.69998 311.5 5.20002L530.1 106.2C538.6 110.1 544 118.6 544 128C544 137.4 538.6 145.9 530.1 149.8L311.5 250.8C296.6 257.7 279.4 257.7 264.5 250.8L45.9 149.8C37.4 145.8 32 137.3 32 128C32 118.7 37.4 110.1 45.9 106.2L264.5 5.20002ZM476.9 209.6L530.1 234.2C538.6 238.1 544 246.6 544 256C544 265.4 538.6 273.9 530.1 277.8L311.5 378.8C296.6 385.7 279.4 385.7 264.5 378.8L45.9 277.8C37.4 273.8 32 265.3 32 256C32 246.7 37.4 238.1 45.9 234.2L99.1 209.6L251.1 279.8C262.67 285.136 275.259 287.9 288 287.9C300.741 287.9 313.33 285.136 324.9 279.8L476.9 209.6ZM324.9 407.8L476.9 337.6L530.1 362.2C538.6 366.1 544 374.6 544 384C544 393.4 538.6 401.9 530.1 405.8L311.5 506.8C296.6 513.7 279.4 513.7 264.5 506.8L45.9 405.8C37.4 401.8 32 393.3 32 384C32 374.7 37.4 366.1 45.9 362.2L99.1 337.6L251.1 407.8C262.67 413.136 275.259 415.9 288 415.9C300.741 415.9 313.33 413.136 324.9 407.8Z" fill={fill}/>
</svg>

  )
}

export function feedbackIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 15L6.92474 18.1137C6.49579 18.548 6.28131 18.7652 6.09695 18.7805C5.93701 18.7938 5.78042 18.7295 5.67596 18.6076C5.55556 18.4672 5.55556 18.162 5.55556 17.5515V15.9916C5.55556 15.444 5.10707 15.0477 4.5652 14.9683C3.25374 14.7762 2.22378 13.7463 2.03168 12.4348C2 12.2186 2 11.9605 2 11.4444V6.8C2 5.11984 2 4.27976 2.32698 3.63803C2.6146 3.07354 3.07354 2.6146 3.63803 2.32698C4.27976 2 5.11984 2 6.8 2H14.2C15.8802 2 16.7202 2 17.362 2.32698C17.9265 2.6146 18.3854 3.07354 18.673 3.63803C19 4.27976 19 5.11984 19 6.8V11M19 22L16.8236 20.4869C16.5177 20.2742 16.3647 20.1678 16.1982 20.0924C16.0504 20.0255 15.8951 19.9768 15.7356 19.9474C15.5558 19.9143 15.3695 19.9143 14.9969 19.9143H13.2C12.0799 19.9143 11.5198 19.9143 11.092 19.6963C10.7157 19.5046 10.4097 19.1986 10.218 18.8223C10 18.3944 10 17.8344 10 16.7143V14.2C10 13.0799 10 12.5198 10.218 12.092C10.4097 11.7157 10.7157 11.4097 11.092 11.218C11.5198 11 12.0799 11 13.2 11H18.8C19.9201 11 20.4802 11 20.908 11.218C21.2843 11.4097 21.5903 11.7157 21.782 12.092C22 12.5198 22 13.0799 22 14.2V16.9143C22 17.8462 22 18.3121 21.8478 18.6797C21.6448 19.1697 21.2554 19.5591 20.7654 19.762C20.3978 19.9143 19.9319 19.9143 19 19.9143V22Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function correlationsIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 12C20 16.4183 16.4183 20 12 20M20 12C20 7.58172 16.4183 4 12 4M20 12H22M12 20C7.58172 20 4 16.4183 4 12M12 20V22M4 12C4 7.58172 7.58172 4 12 4M4 12H2M12 4V2M15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
  
export function questionsIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 20V13M12 20V10M4 20L4 16M13.4067 5.0275L18.5751 6.96567M10.7988 5.40092L5.20023 9.59983M21.0607 6.43934C21.6464 7.02513 21.6464 7.97487 21.0607 8.56066C20.4749 9.14645 19.5251 9.14645 18.9393 8.56066C18.3536 7.97487 18.3536 7.02513 18.9393 6.43934C19.5251 5.85355 20.4749 5.85355 21.0607 6.43934ZM5.06066 9.43934C5.64645 10.0251 5.64645 10.9749 5.06066 11.5607C4.47487 12.1464 3.52513 12.1464 2.93934 11.5607C2.35355 10.9749 2.35355 10.0251 2.93934 9.43934C3.52513 8.85355 4.47487 8.85355 5.06066 9.43934ZM13.0607 3.43934C13.6464 4.02513 13.6464 4.97487 13.0607 5.56066C12.4749 6.14645 11.5251 6.14645 10.9393 5.56066C10.3536 4.97487 10.3536 4.02513 10.9393 3.43934C11.5251 2.85355 12.4749 2.85355 13.0607 3.43934Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function questionAnalyticsIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 8.00224C10.1762 7.50136 10.524 7.07901 10.9817 6.80998C11.4395 6.54095 11.9777 6.4426 12.501 6.53237C13.0243 6.62213 13.499 6.89421 13.8409 7.30041C14.1829 7.70661 14.37 8.22072 14.3692 8.75168C14.3692 10.2506 12.1209 11 12.1209 11M12.1499 14H12.1599M7 18V20.3355C7 20.8684 7 21.1348 7.10923 21.2716C7.20422 21.3906 7.34827 21.4599 7.50054 21.4597C7.67563 21.4595 7.88367 21.2931 8.29976 20.9602L10.6852 19.0518C11.1725 18.662 11.4162 18.4671 11.6875 18.3285C11.9282 18.2055 12.1844 18.1156 12.4492 18.0613C12.7477 18 13.0597 18 13.6837 18H16.2C17.8802 18 18.7202 18 19.362 17.673C19.9265 17.3854 20.3854 16.9265 20.673 16.362C21 15.7202 21 14.8802 21 13.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14C3 14.93 3 15.395 3.10222 15.7765C3.37962 16.8117 4.18827 17.6204 5.22354 17.8978C5.60504 18 6.07003 18 7 18Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}


export function recommendationIcon(fill){
  return (

    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13 8V16C13 16.7956 12.6839 17.5587 12.1213 18.1213C11.5587 18.6839 10.7956 19 10 19H7.83C7.59409 19.6675 7.1298 20.2301 6.51919 20.5884C5.90858 20.9466 5.19098 21.0775 4.49321 20.9578C3.79545 20.8381 3.16246 20.4756 2.70613 19.9344C2.2498 19.3931 1.99951 18.708 1.99951 18C1.99951 17.292 2.2498 16.6069 2.70613 16.0656C3.16246 15.5244 3.79545 15.1619 4.49321 15.0422C5.19098 14.9225 5.90858 15.0534 6.51919 15.4116C7.1298 15.7699 7.59409 16.3325 7.83 17H10C10.2652 17 10.5196 16.8946 10.7071 16.7071C10.8946 16.5196 11 16.2652 11 16V8C11 7.20435 11.3161 6.44129 11.8787 5.87868C12.4413 5.31607 13.2044 5 14 5H17V2L22 6L17 10V7H14C13.7348 7 13.4804 7.10536 13.2929 7.29289C13.1054 7.48043 13 7.73478 13 8Z" fill={fill}/>
</svg>

  )
}


export function outcomesIcon(fill){
  return (

    <svg width="15" height="15" viewBox="0 0 192 192" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M176 0H16C11.7565 0 7.68687 1.68571 4.68629 4.68629C1.68571 7.68687 0 11.7565 0 16V176C0 180.243 1.68571 184.313 4.68629 187.314C7.68687 190.314 11.7565 192 16 192H176C180.243 192 184.313 190.314 187.314 187.314C190.314 184.313 192 180.243 192 176V16C192 11.7565 190.314 7.68687 187.314 4.68629C184.313 1.68571 180.243 0 176 0ZM176 176H16V16H176V176ZM58.34 133.66C57.5962 132.917 57.0061 132.035 56.6035 131.064C56.2009 130.092 55.9937 129.051 55.9937 128C55.9937 126.949 56.2009 125.908 56.6035 124.936C57.0061 123.965 57.5962 123.083 58.34 122.34L108.69 72H80C77.8783 72 75.8434 71.1571 74.3431 69.6569C72.8429 68.1566 72 66.1217 72 64C72 61.8783 72.8429 59.8434 74.3431 58.3431C75.8434 56.8429 77.8783 56 80 56H128C130.122 56 132.157 56.8429 133.657 58.3431C135.157 59.8434 136 61.8783 136 64V112C136 114.122 135.157 116.157 133.657 117.657C132.157 119.157 130.122 120 128 120C125.878 120 123.843 119.157 122.343 117.657C120.843 116.157 120 114.122 120 112V83.31L69.66 133.66C68.917 134.404 68.0347 134.994 67.0635 135.396C66.0923 135.799 65.0513 136.006 64 136.006C62.9487 136.006 61.9077 135.799 60.9365 135.396C59.9653 134.994 59.083 134.404 58.34 133.66Z" fill={fill}/>
</svg>



  )
}

export function aiIcon(fill) {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3111 14.0751C15.1214 14.0751 14.9617 14.0122 14.8319 13.8863C14.7021 13.7605 14.6372 13.6056 14.6372 13.4217V7.19323C14.6372 7.00933 14.7021 6.85447 14.8319 6.72864C14.9617 6.59313 15.1214 6.52538 15.3111 6.52538C15.5108 6.52538 15.6755 6.58829 15.8053 6.71412C15.9351 6.83995 16 6.99965 16 7.19323V13.4217C16 13.6056 15.9301 13.7605 15.7903 13.8863C15.6605 14.0122 15.5008 14.0751 15.3111 14.0751Z"
        fill={fill}
      />
      <path
        d="M14.8265 5.03815C14.9526 5.16048 15.1041 5.22165 15.2807 5.22165H15.3564C15.5331 5.22165 15.6845 5.16048 15.8107 5.03815C15.9369 4.91581 16 4.76901 16 4.59774V4.54881C16 4.37754 15.9369 4.23074 15.8107 4.10841C15.6845 3.98607 15.5331 3.9249 15.3564 3.9249H15.2807C15.1041 3.9249 14.9526 3.98607 14.8265 4.10841C14.7003 4.23074 14.6372 4.37754 14.6372 4.54881V4.59774C14.6372 4.76901 14.7003 4.91581 14.8265 5.03815Z"
        fill={fill}
      />
      <path
        d="M0.688892 3.92805C0.878587 3.92805 1.03833 3.99092 1.16812 4.11666C1.29791 4.2424 1.36281 4.39715 1.36281 4.58093V10.805C1.36281 10.9888 1.29791 11.1435 1.16812 11.2693C1.03833 11.4047 0.878587 11.4724 0.688892 11.4724C0.489213 11.4724 0.324477 11.4095 0.194685 11.2838C0.0648939 11.1581 0 10.9985 0 10.805V4.58093C0 4.39715 0.0698868 4.2424 0.209662 4.11666C0.339454 3.99092 0.499197 3.92805 0.688892 3.92805Z"
        fill={fill}
      />
      <path
        d="M1.17355 12.9594C1.04736 12.8372 0.895935 12.7761 0.719272 12.7761H0.643561C0.466899 12.7761 0.315473 12.8372 0.189285 12.9594C0.0630978 13.0817 4.02553e-06 13.2284 4.02553e-06 13.3995V13.4484C4.02553e-06 13.6196 0.0630978 13.7663 0.189285 13.8885C0.315473 14.0108 0.466899 14.0719 0.643561 14.0719H0.719272C0.895935 14.0719 1.04736 14.0108 1.17355 13.8885C1.29974 13.7663 1.36283 13.6196 1.36283 13.4484V13.3995C1.36283 13.2284 1.29974 13.0817 1.17355 12.9594Z"
        fill={fill}
      />
      <path
        d="M10.9786 1.9657C10.9786 1.60086 11.2836 1.3051 11.66 1.3051C12.0363 1.3051 12.3414 1.60086 12.3414 1.9657V16.0343C12.3414 16.3991 12.0363 16.6949 11.66 16.6949C11.2836 16.6949 10.9786 16.3991 10.9786 16.0343V1.9657Z"
        fill={fill}
      />
      <path
        d="M3.66131 1.9657C3.66131 1.60086 3.96638 1.3051 4.34271 1.3051C4.71904 1.3051 5.02412 1.60086 5.02412 1.9657V16.0343C5.02412 16.3991 4.71904 16.6949 4.34271 16.6949C3.96638 16.6949 3.66131 16.3991 3.66131 16.0343V1.9657Z"
        fill={fill}
      />
      <path
        d="M7.31992 0.660599C7.31992 0.29576 7.625 0 8.00133 0C8.37766 0 8.68273 0.29576 8.68273 0.660599V7.68763C8.68273 8.05247 8.37766 8.34823 8.00133 8.34823C7.625 8.34823 7.31992 8.05247 7.31992 7.68763V0.660599Z"
        fill={fill}
      />
      <path
        d="M7.31992 10.3124C7.31992 9.94753 7.625 9.65177 8.00133 9.65177C8.37766 9.65177 8.68273 9.94753 8.68273 10.3124V17.3394C8.68273 17.7042 8.37766 18 8.00133 18C7.625 18 7.31992 17.7042 7.31992 17.3394V10.3124Z"
        fill={fill}
      />
    </svg>
  );
}

export function dashboardIcon(fill) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5789 3C20.3638 3 21 3.63623 21 4.42105L21 19.5789C21 20.3638 20.3638 21 19.5789 21L4.42105 21C3.63623 21 3 20.3638 3 19.5789L3 4.42105C3 3.63623 3.63622 3 4.42105 3L19.5789 3ZM20.0526 4.42105C20.0526 4.15944 19.8406 3.94737 19.5789 3.94737L4.42105 3.94737C4.15944 3.94737 3.94737 4.15944 3.94737 4.42105L3.94737 19.5789C3.94737 19.8406 4.15944 20.0526 4.42105 20.0526L19.5789 20.0526C19.8406 20.0526 20.0526 19.8406 20.0526 19.5789L20.0526 4.42105Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 7.5C3 7.22386 3.21208 7 3.47368 7H20.5263C20.7879 7 21 7.22386 21 7.5C21 7.77614 20.7879 8 20.5263 8H3.47368C3.21208 8 3 7.77614 3 7.5Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 7C9.77614 7 10 7.22386 10 7.5V20.5C10 20.7761 9.77614 21 9.5 21C9.22386 21 9 20.7761 9 20.5V7.5C9 7.22386 9.22386 7 9.5 7Z"
        fill={fill}
      />
    </svg>
  );
}

export function dashboardIconNew(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 9L11.5657 14.4343C11.3677 14.6323 11.2687 14.7313 11.1545 14.7684C11.0541 14.8011 10.9459 14.8011 10.8455 14.7684C10.7313 14.7313 10.6323 14.6323 10.4343 14.4343L8.56569 12.5657C8.36768 12.3677 8.26867 12.2687 8.15451 12.2316C8.05409 12.1989 7.94591 12.1989 7.84549 12.2316C7.73133 12.2687 7.63232 12.3677 7.43431 12.5657L3 17M17 9H13M17 9V13M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}


export function analyticsIcon(fill) {

  return (
    <svg width="18" height="16" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 10.5C1.72386 10.5 1.5 10.7239 1.5 11V18C1.5 18.2761 1.72386 18.5 2 18.5H4C4.27614 18.5 4.5 18.2761 4.5 18V11C4.5 10.7239 4.27614 10.5 4 10.5H2ZM0.5 11C0.5 10.1716 1.17157 9.5 2 9.5H4C4.82843 9.5 5.5 10.1716 5.5 11V18C5.5 18.8284 4.82843 19.5 4 19.5H2C1.17157 19.5 0.5 18.8284 0.5 18V11Z" fill={fill}/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 1.5C9.72386 1.5 9.5 1.72386 9.5 2V18C9.5 18.2761 9.72386 18.5 10 18.5H12C12.2761 18.5 12.5 18.2761 12.5 18V2C12.5 1.72386 12.2761 1.5 12 1.5H10ZM8.5 2C8.5 1.17157 9.17157 0.5 10 0.5H12C12.8284 0.5 13.5 1.17157 13.5 2V18C13.5 18.8284 12.8284 19.5 12 19.5H10C9.17157 19.5 8.5 18.8284 8.5 18V2Z" fill={fill}/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18 5.5C17.7239 5.5 17.5 5.72386 17.5 6V18C17.5 18.2761 17.7239 18.5 18 18.5H20C20.2761 18.5 20.5 18.2761 20.5 18V6C20.5 5.72386 20.2761 5.5 20 5.5H18ZM16.5 6C16.5 5.17157 17.1716 4.5 18 4.5H20C20.8284 4.5 21.5 5.17157 21.5 6V18C21.5 18.8284 20.8284 19.5 20 19.5H18C17.1716 19.5 16.5 18.8284 16.5 18V6Z" fill={fill}/>
    </svg>

  )

}



export function benchmarkIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 7H4.6C4.03995 7 3.75992 7 3.54601 7.10899C3.35785 7.20487 3.20487 7.35785 3.10899 7.54601C3 7.75992 3 8.03995 3 8.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21H9M9 21H15M9 21L9 4.6C9 4.03995 9 3.75992 9.10899 3.54601C9.20487 3.35785 9.35785 3.20487 9.54601 3.10899C9.75992 3 10.0399 3 10.6 3L13.4 3C13.9601 3 14.2401 3 14.454 3.10899C14.6422 3.20487 14.7951 3.35785 14.891 3.54601C15 3.75992 15 4.03995 15 4.6V21M15 11H19.4C19.9601 11 20.2401 11 20.454 11.109C20.6422 11.2049 20.7951 11.3578 20.891 11.546C21 11.7599 21 12.0399 21 12.6V19.4C21 19.9601 21 20.2401 20.891 20.454C20.7951 20.6422 20.6422 20.7951 20.454 20.891C20.2401 21 19.9601 21 19.4 21H15"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function heatmapIcon(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 9H21M3 15H21M12 3V21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function reportIcon(fill) {

  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginLeft:-2}}>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13 7.5V3.5H14V7.5C14 8.32842 14.6716 9 15.5 9H19.5V10H15.5C14.1193 10 13 8.88071 13 7.5Z" fill={fill}/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M19 9.32842C19 8.9306 18.842 8.54907 18.5607 8.26777L14.7322 4.43934C14.4509 4.15803 14.0694 4 13.6716 4L7.5 4.00002C6.67157 4.00002 6 4.67159 6 5.50001V19.5C6 20.3284 6.67157 21 7.5 21H17.5C18.3284 21 19 20.3284 19 19.5V9.32842ZM19.2678 7.56066C19.7366 8.0295 20 8.66538 20 9.32842V19.5C20 20.8807 18.8807 22 17.5 22H7.5C6.11929 22 5 20.8807 5 19.5V5.50001C5 4.1193 6.11928 3.00002 7.49999 3.00002L13.6716 3C14.3346 3 14.9705 3.26339 15.4393 3.73223L19.2678 7.56066Z" fill={fill}/>
    </svg>

  )
}

export function reportIconNew(fill) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginLeft: -2 }}
    >
      <path
        d="M3 8L15 8M15 8C15 9.65686 16.3431 11 18 11C19.6569 11 21 9.65685 21 8C21 6.34315 19.6569 5 18 5C16.3431 5 15 6.34315 15 8ZM9 16L21 16M9 16C9 17.6569 7.65685 19 6 19C4.34315 19 3 17.6569 3 16C3 14.3431 4.34315 13 6 13C7.65685 13 9 14.3431 9 16Z"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function sharingIcon(fill){

  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16.9941 1.3961C17.0174 1.15918 16.8408 0.982643 16.6039 1.00586C15.2862 1.13499 12.8778 1.54313 10.6962 2.81359L15.1864 7.30379C16.4569 5.12215 16.865 2.71376 16.9941 1.3961ZM14.6281 8.16498L9.83502 3.37185C9.43242 3.66209 9.04546 3.98646 8.68296 4.34897C8.20446 4.82747 8.07294 4.98386 7.82928 5.27361C7.7145 5.41009 7.57483 5.57617 7.36229 5.81945C5.7062 7.71506 4.36245 9.53055 3.6411 10.5447C3.60154 10.6003 3.56387 10.6535 3.52813 10.7041C3.39658 10.8905 3.41706 11.1484 3.58699 11.3183L6.68167 14.413C6.85159 14.5829 7.10952 14.6034 7.29591 14.4719C7.34655 14.4361 7.39973 14.3985 7.45534 14.3589C8.46945 13.6376 10.2849 12.2938 12.1805 10.6377C12.4238 10.4252 12.5899 10.2855 12.7264 10.1707C13.0161 9.92706 13.1725 9.79554 13.651 9.31704C14.0135 8.95454 14.3379 8.56758 14.6281 8.16498ZM16.506 0.00694211C17.3725 -0.0779691 18.078 0.627531 17.9931 1.49399C17.8472 2.98257 17.3586 5.87309 15.6973 8.38291C15.3174 8.95681 14.8753 9.51224 14.3608 10.0268C13.8513 10.5363 13.6606 10.6967 13.3542 10.9546C13.3206 10.9829 13.2855 11.0124 13.2485 11.0437L13.8492 11.6444C14.3075 12.1026 14.4211 12.8027 14.1312 13.3823L12.2386 17.1675C11.7791 18.0866 10.5541 18.2854 9.82744 17.5588L7.67789 15.4092C7.11193 15.6897 6.42464 15.5754 5.97194 15.1227L2.87726 12.0281C2.42457 11.5754 2.31032 10.8881 2.59077 10.3221L0.441215 8.17256C-0.285429 7.44592 -0.0866386 6.22093 0.832499 5.76136L4.6177 3.86876C5.19732 3.57895 5.89736 3.69255 6.3556 4.15078L6.95634 4.75152C6.98761 4.71449 7.01711 4.67943 7.04544 4.64577C7.30328 4.33939 7.46374 4.14873 7.97323 3.63924C8.48776 3.12471 9.04319 2.6826 9.61709 2.30272C12.1269 0.641433 15.0174 0.15282 16.506 0.00694211ZM6.29921 5.51385L5.64587 4.86051C5.49313 4.70776 5.25978 4.6699 5.06657 4.7665L1.28137 6.6591C0.97499 6.81229 0.908726 7.22062 1.15094 7.46283L3.16945 9.48135C3.89111 8.48815 4.98707 7.04229 6.29921 5.51385ZM8.51865 14.8305L10.5372 16.8491C10.7794 17.0913 11.1877 17.025 11.3409 16.7186L13.2335 12.9334C13.3301 12.7402 13.2922 12.5069 13.1395 12.3541L12.4862 11.7008C10.9577 13.0129 9.51185 14.1089 8.51865 14.8305Z" fill={fill}/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M2.96291 14.9953C3.08137 14.9268 3.16852 14.86 3.22685 14.7998C3.26228 14.7632 3.27949 14.7371 3.28763 14.7219C3.28255 14.7152 3.27488 14.7062 3.26352 14.6948M2.96291 14.9953C3.03144 14.8769 3.09818 14.7897 3.15838 14.7314C3.19498 14.696 3.2211 14.6788 3.23636 14.6706C3.24308 14.6757 3.25212 14.6834 3.26352 14.6948M3.19716 13.6621C3.50679 13.6475 3.7723 13.7842 3.97316 13.985C4.17402 14.1858 4.31079 14.4514 4.2962 14.761C4.28215 15.0591 4.13177 15.3082 3.94775 15.4982C3.58951 15.868 2.97887 16.1483 2.2332 16.3326L1.42618 16.532L1.62561 15.725C1.80988 14.9794 2.09022 14.3687 2.46002 14.0105C2.64998 13.8265 2.8991 13.6761 3.19716 13.6621Z" fill={fill}/>
</svg>
  )
}

export function layers(fill) {

  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M11.7764 3.55279C11.9172 3.4824 12.0828 3.4824 12.2236 3.55279L20.2236 7.55282C20.393 7.63752 20.5 7.81065 20.5 8.00004C20.5 8.18942 20.393 8.36255 20.2236 8.44725L12.2236 12.4472C12.0828 12.5176 11.9172 12.5176 11.7764 12.4472L3.77639 8.44725C3.607 8.36255 3.5 8.18942 3.5 8.00004C3.5 7.81065 3.607 7.63752 3.77639 7.55282L11.7764 3.55279ZM5.11803 8.00003L12 11.441L18.882 8.00003L12 4.55902L5.11803 8.00003Z" fill={fill}/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.5529 11.7765C3.67639 11.5295 3.97673 11.4294 4.22371 11.5529L12.0001 15.441L19.7765 11.5529C20.0235 11.4294 20.3238 11.5295 20.4473 11.7765C20.5708 12.0235 20.4707 12.3238 20.2237 12.4473L12.2237 16.4473C12.083 16.5176 11.9173 16.5176 11.7765 16.4473L3.7765 12.4473C3.52951 12.3238 3.4294 12.0235 3.5529 11.7765Z" fill={fill}/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.5529 15.7764C3.67639 15.5294 3.97673 15.4293 4.22371 15.5528L12.0001 19.441L19.7765 15.5528C20.0235 15.4293 20.3238 15.5294 20.4473 15.7764C20.5708 16.0234 20.4707 16.3237 20.2237 16.4472L12.2237 20.4472C12.083 20.5176 11.9173 20.5176 11.7765 20.4472L3.7765 16.4472C3.52951 16.3237 3.4294 16.0234 3.5529 15.7764Z" fill={fill}/>
</svg>

  )
}
